<h3 color="primary" class="popup-header">Physician Details</h3>
<mat-dialog-content class="mat-typography">
  <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
    <mat-card class="generalInfo">
      <mat-card-header>
        <mat-card-title>
          <span class="card-title-text">Client Information / Contact Information</span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ul class="generalInfo_details">
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">Business Name</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{clientInfo?.businessName}}</li>

            <li fxFlex="11">Contact Person</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{clientInfo?.contactPerson}}</li>

            <li fxFlex="11">Phone Number</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{clientInfo?.contactNumber}}</li>
          </div>
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">Fax Number</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{clientInfo?.faxNumber}}</li>

            <li fxFlex="11">Email Address</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="50" primaryColor>{{clientInfo?.contactEmail}}</li>
          </div>
        </ul>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
    <mat-card class="generalInfo">
      <mat-card-header>
        <mat-card-title>
          <span class="card-title-text">Physician Information</span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ul class="generalInfo_details">
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">Last Name</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{physicianInfo?.lastName}}</li>

            <li fxFlex="11">First Name</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{physicianInfo?.firstName}}</li>

            <li fxFlex="11">Middle Initial</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{physicianInfo?.middleInitial}}</li>
          </div>
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">Title</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{physicianInfo?.title}}</li>

            <li fxFlex="11">NPI</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{physicianInfo?.npi}}</li>

            <li fxFlex="11">Report Partial Results</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{physicianInfo?.reportPartialResults ? 'Yes' : 'No'}}</li>
          </div>

          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">Enable</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{physicianInfo?.enabled ? 'Yes' : 'No'}}</li>

            <li fxFlex="11">Signature</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>
              <img *ngIf="physicianInfo?.signatureImage" style="width: 100%;" [src]="physicianInfo?.signatureImage" />
            </li>
          </div>
        </ul>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
    <mat-card class="generalInfo">
      <mat-card-header>
        <mat-card-title>
          <span class="card-title-text">Address</span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ul class="generalInfo_details">
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">Address 1</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{physicianInfo?.address1}}</li>

            <li fxFlex="11">Address 2</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{physicianInfo?.address2}}</li>

            <li fxFlex="11">City</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{physicianInfo?.city}}</li>
          </div>
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">State</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{physicianInfo?.stateName}}</li>

            <li fxFlex="11">Zip Code</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{physicianInfo?.zip}}</li>
          </div>
        </ul>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
    <mat-card class="generalInfo">
      <mat-card-header>
        <mat-card-title>
          <span class="card-title-text">Notes</span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ul class="generalInfo_details">
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="100" primaryColor>{{physicianInfo?.notes}}</li>
          </div>
        </ul>
      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="popup-footer">
  <button mat-raised-button color="warn" (click)="cancelClick()">
    <i class="fas fa-times"></i> Close
  </button>
</mat-dialog-actions>